import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/4.4.0/js/sparta-style-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import DataAssetLoader from "utilities/suits/data-asset-loader/2.1.1/js/data-asset-loader";



function insertPositionInOptions(options, insert) {
  return { ...options, insert };
}

class spartaMessageUtility {
  constructor() {
    this._options = {
      listType: 'ordered',
      dismiss: false,
      border: null,
      insert: 'before',
      size: 'large',
      uuid: (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1),
      remind: false,
      neverShow: false,
    };


    this._type = 'info';

    this.language = spartaStoreUtility.getData('lang');
  }

  title(title) {
    this._title = title || '';
    return this;
  }

  message(msg) {
    this._message = msg || '';
    return this;
  }

  type(type) {
    if (type) {
      this._type = type;
    }

    return this;
  }

  show(target, localOptions = {}) {
    this._target = target;
    let template;


    const opts = { ...this._options, ...localOptions };
    this._options = opts;

    if (!opts.neverShow || !opts.remind) {
      if (!this.importTriggered) {
        this.loadMessageIcons().then((xhr) => {
          this.dismissADALabel = xhr.dismissADALabel;
          this.dismissMessage = xhr.dismissMessage;
          this.messageIconText = xhr.messageIconText;
          this.importTriggered = true;


          template = this.buildTemplate();


          this.attach(template);
          this.addListeners();
        });
      } else {

        template = this.buildTemplate();


        this.attach(template);
        this.addListeners();
      }
    }
    return this;
  }

  buildTemplate() {
    const content = this.formatMessage();
    let style = '';
    let dismiss = '';
    let remind = '';
    let neverShow = '';
    let titleClass = '';
    let dismissClass = '';
    let dismissContainer = '';

    if (this._options.border !== null) {
      style = `style="border-width: ${this._options.border}"`;
    }

    if (this._options.dismiss) {
      dismissClass = 'dismiss';
      if (this.dismissADALabel === undefined) {
        this.dismissADALabel = '';
      }

      dismiss = `<a role="button" class="spartaMessage-close-x" href="javascript:void(0); aria-hidden="true"><span class="spa-icon icon-close"></span><span class="ada-hidden">${this.dismissADALabel}${this.dismissMessage}</span></a>`;
      dismissContainer = `<div class="spartaMessage-dismiss">${dismiss}</div>`;
    }

    if (this._options.remind === false) {
      remind = '<span class="spartaMessage-remind-me-later">Remind Me Later</span>';
    } else {
      remind = '';
    }

    if (this._options.neverShow === false) {
      remind = '<span class="spartaMessage-never-show>Never Show Again</span>';
    } else {
      neverShow = '';
    }


    const messageText = this.messageIconText;
    const adaText = messageText[this._type];


    const title = this._title !== ''
      ? `<p class="spartaMessage-title">${this._title}</p>`
      : '';

    if (!this._title) {
      titleClass = 'no-title';
    }

    return `<div id="sparta-message-${this._options.uuid}" class="spartaMessage ${this._type} ${this._options.size}" ${style} tabIndex="0">
              <div class="spartaMessage-icon">
                <span class="ada-hidden">${adaText}</span>
                <span class="data-icon"></span>
              </div>
              <div class="spartaMessage-content ${titleClass} ${dismissClass}">
                ${title}
                ${content}
              </div>
              ${dismissContainer}
              <div class="spartaMessage-remind">
                ${remind}
              </div>
              <div class="spartaMessage-neverShow">
                ${neverShow}
              </div>
            </div>`;
  }

  formatMessage() {
    if (Array.isArray(this._message)) {
      let str = '';
      let startWrap = '';
      let endWrap = '';

      if (
        this._options.listType === 'ordered' ||
        this._options.listType === 'unordered'
      ) {
        startWrap = '<li role="listitem">';
        endWrap = '</li>';
      }

      if (this._options.listType === 'paragraph') {
        startWrap = '<p>';
        endWrap = '</p>';
      }

      str +=
        this._options.listType === 'ordered'
          ? '<ul class="spartaMessage-list" role="list">'
          : '';
      str +=
        this._options.listType === 'unordered'
          ? '<ol class="spartaMessage-list">'
          : '';

      this._message.forEach((item) => {
        str += `${startWrap}${item}${endWrap}`;
      });

      str += this._options.listType === 'ordered' ? '</ul>' : '';
      str += this._options.listType === 'unordered' ? '</ol>' : '';

      return str;
    }

    return this._message !== ''
      ? `<p class="spartaMessage-text">${this._message}</p>`
      : '';
  }

  destroy() {
    const { uuid } = this._options;

    if (!uuid) return false;

    const id = `sparta-message-${uuid}`;

    const element = document.getElementById(id);

    if (element) {
      element.parentNode.removeChild(element);
    }

    return false;
  }

  attach(template) {
    const el = this._target instanceof Element
      ? this._target
      : document.querySelector(this._target);

    switch (this._options.insert) {
      case 'before':
        el.insertAdjacentHTML('beforebegin', template);
        break;

      case 'after':
        el.insertAdjacentHTML('afterend', template);
        break;

      case 'insideFirst':
      case 'prepend':
        el.insertAdjacentHTML('afterbegin', template);
        break;

      case 'insideLast':
      case 'append':
        el.insertAdjacentHTML('beforeend', template);
        break;

      case 'replace':
      default:
        el.innerHTML = template;
    }
  }

  loadMessageIcons() {
    const lang = spartaStoreUtility.getData('jcrLang');


    const messagingAssetLoader = new DataAssetLoader(
      'global/sparta-messaging-utility',
      `data/${lang}`,
    );



    const load = messagingAssetLoader.loadAsset('messaging.json');




    const assetLoaderPromise = new Promise((resolve) => {




      spartaEventsUtility.sub(
        load.success,
        (evtData) => {

          resolve(evtData.data.xhr);
        },
        true,
      );
    });

    spartaEventsUtility.sub(
      load.failure,
      (evtData) => {

        if (window.console && console.warn) {
          console.warn(
            `Sparta Messaging: ${evtData.data.filename} AJAX Error.`,
            evtData.data.xhr,
          );
        }
      },
      true,
    );

    return assetLoaderPromise;
  }

  addListeners() {
    if (this._options.dismiss) {
      const closeIconSelector = `#sparta-message-${this._options.uuid} .spartaMessage-close-x`;
      const closeIcon = document.querySelector(closeIconSelector);
      closeIcon.addEventListener('click', this.close);
    }
  }

  close(evt) {
    evt.preventDefault();

    const element = evt.target.closest('.spartaMessage');

    element.parentNode.removeChild(element);

    return false;
  }







  showWithProvidedData(target, {
    type, title, message, options,
  }) {
    this._type = type;
    this._title = title;
    this._message = message;
    this.options = options;

    return this.show(target, options);
  }

  showMessage(target, type, title, message, options = {}) {
    const data = {
      type,
      title,
      message,
      options,
    };

    return this.showWithProvidedData(target, data);
  }

  showBefore(target, options = {}) {
    options.insert = 'before';
    return this.show(target, options);
  }

  showAfter(target, options = {}) {
    options.insert = 'after';
    return this.show(target, options);
  }

  prepend(target, options = {}) {
    options.insert = 'prepend';

    return this.show(target, options);
  }

  showInsideFirst(target, options = {}) {
    return this.prepend(target, options);
  }

  append(target, options = {}) {
    options.insert = 'insideLast';

    return this.show(target, options);
  }

  showInsideLast(target, options = {}) {
    return this.append(target, options);
  }

  showErrorMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'error', title, message, options);
  }

  showErrorMessageBefore(target, title, message, options = {}) {
    return this.showErrorMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'before'),
    );
  }

  showErrorMessageAfter(target, title, message, options = {}) {
    return this.showErrorMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'after'),
    );
  }

  showErrorMessageInsideFirst(target, title, message, options = {}) {
    return this.showErrorMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'prepend'),
    );
  }

  showErrorMessageInsideLast(target, title, message, options = {}) {
    return this.showErrorMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'append'),
    );
  }

  showSuccessMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'success', title, message, options);
  }

  showSuccessMessageBefore(target, title, message, options = {}) {
    return this.showSuccessMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'before'),
    );
  }

  showSuccessMessageAfter(target, title, message, options = {}) {
    return this.showSuccessMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'after'),
    );
  }

  showSuccessMessageInsideFirst(target, title, message, options = {}) {
    return this.showSuccessMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'prepend'),
    );
  }

  showSuccessMessageInsideLast(target, title, message, options = {}) {
    return this.showSuccessMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'append'),
    );
  }

  showWarningMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'warning', title, message, options);
  }

  showWarningMessageBefore(target, title, message, options = {}) {
    return this.showWarningMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'before'),
    );
  }

  showWarningMessageAfter(target, title, message, options = {}) {
    return this.showWarningMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'after'),
    );
  }

  showWarningMessageInsideFirst(target, title, message, options = {}) {
    return this.showWarningMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'prepend'),
    );
  }

  showWarningMessageInsideLast(target, title, message, options = {}) {
    return this.showWarningMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'append'),
    );
  }

  showInfoMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'info', title, message, options);
  }

  showInfoMessageBefore(target, title, message, options = {}) {
    return this.showInfoMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'before'),
    );
  }

  showInfoMessageAfter(target, title, message, options = {}) {
    return this.showInfoMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'after'),
    );
  }

  showInfoMessageInsideFirst(target, title, message, options = {}) {
    return this.showInfoMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'prepend'),
    );
  }

  showInfoMessageInsideLast(target, title, message, options = {}) {
    return this.showInfoMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'append'),
    );
  }

  showHelpMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'help', title, message, options);
  }

  showHelpMessageBefore(target, title, message, options = {}) {
    return this.showHelpMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'before'),
    );
  }

  showHelpMessageAfter(target, title, message, options = {}) {
    return this.showHelpMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'after'),
    );
  }

  showHelpMessageInsideFirst(target, title, message, options = {}) {
    return this.showHelpMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'prepend'),
    );
  }

  showHelpMessageInsideLast(target, title, message, options = {}) {
    return this.showHelpMessage(
      target,
      title,
      message,
      insertPositionInOptions(options, 'append'),
    );
  }
}

spartaSingletonUtility('SpartaMessagingUtility', () => spartaMessageUtility);
export default spartaMessageUtility;
